var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8463 10.1529C18.0512 10.3567 18.0512 10.6871 17.8463 10.8909L10.8954 17.8071C10.6906 18.0109 10.3585 18.0109 10.1536 17.8071C9.94879 17.6033 9.94879 17.2728 10.1536 17.069L17.1046 10.1529C17.3094 9.94905 17.6415 9.94905 17.8463 10.1529Z",
    fill: "#7D899D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1537 10.195C10.3585 9.99124 10.6906 9.99124 10.8954 10.195L17.8464 17.1112C18.0512 17.315 18.0512 17.6455 17.8464 17.8493C17.6415 18.0531 17.3094 18.0531 17.1046 17.8493L10.1537 10.9331C9.94885 10.7293 9.94885 10.3989 10.1537 10.195Z",
    fill: "#7D899D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.e802906fada823b10ff85ea0113b7004.svg";
export { ForwardRef as ReactComponent };